import { render, staticRenderFns } from "./ModalSendInvoice.vue?vue&type=template&id=ca55fc8c"
import script from "./ModalSendInvoice.vue?vue&type=script&lang=js"
export * from "./ModalSendInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports